(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["verified-card-specs"] && !Shopify.designMode) return;
  try {
    function buildRows(source, DOMParserClass) {
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim();
  const normalize = value => clean(value).toLowerCase().replace(/[^a-z0-9]/g, '');
  if (!source || !Array.isArray(source.tags) || !Array.isArray(source.expectedTags)) return [];
  const signature = tags => tags.map(normalize).sort().join('|');
  if (signature(source.tags) !== signature(source.expectedTags)) return [];
  const doc = new DOMParserClass().parseFromString(source.description, 'text/html');
  let values;
  if (source.kind === 'gmr') {
    const heading = Array.from(doc.querySelectorAll('p')).find(p => clean(p.textContent) === 'Specificaties');
    const paragraph = heading && heading.nextElementSibling;
    if (!paragraph) return [];
    const lines = paragraph.innerHTML.split(/<br\s*\/?\s*>/i).map(html => clean(new DOMParserClass().parseFromString('<p>' + html + '</p>', 'text/html').querySelector('p').textContent).replace(/^•\s*/, ''));
    const table = new Map(Array.from(doc.querySelectorAll('table tr')).map(row => [clean(row.querySelector('th')?.textContent), clean(row.querySelector('td')?.textContent)]));
    values = [lines[0], table.get('Grafische chip'), clean([table.get('Werkgeheugen'), table.get('Geheugentype')].filter(Boolean).join(' ')), table.get('Opslagtype') === 'SSD' ? table.get('Opslagcapaciteit') : ''];
  } else if (source.kind === 'screenon') {
    doc.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
    const lines = doc.documentElement.textContent.split(/\r?\n/).map(clean);
    const take = label => {
      const matches = lines.filter(line => line.startsWith(label + ':'));
      return matches.length === 1 ? clean(matches[0].slice(label.length + 1)) : '';
    };
    values = [take('Processor').split(' - ')[0], take('Videokaart'), take('RAM'), take('SSD')];
  } else return [];
  if (values.length !== 4 || values.some(value => !value || value.length > 160)) return [];
  if (source.metafields) {
    const keys = ['cpu', 'gpu', 'ram', 'ssd'];
    const required = source.kind === 'screenon' ? keys : ['cpu'];
    if (required.some(key => !clean(source.metafields[key]))) return [];
    if (keys.some((key, i) => clean(source.metafields[key]) && normalize(source.metafields[key]) !== normalize(values[i]))) return [];
    values = values.map((value, i) => clean(source.metafields[keys[i]]) || value);
  }
  return ['CPU', 'GPU', 'RAM', 'SSD'].map((label, i) => [label, clean(values[i])]);
}

function installCardsAsync(document, registry, loadSource, DOMParserClass, ObserverClass, scheduleFrame) {
  const cache = new Map();
  const pending = new WeakMap();
  const approved = new Map(registry.map(record => [record.handle, record]));
  const sourceFor = record => {
    if (!cache.has(record.handle)) {
      cache.set(record.handle, Promise.resolve().then(() => loadSource(record.handle)).then(source => {
        if (!source || String(source.id) !== String(record.id) || source.handle !== record.handle || source.title !== record.title) return [];
        return buildRows(source, DOMParserClass);
      }).catch(() => []));
    }
    return cache.get(record.handle);
  };
  const scan = () => {
    document.querySelectorAll('a.product-item__title').forEach(anchor => {
      const card = anchor.closest('.product-item');
      if (!card) return;
      const handle = new URL(anchor.href, 'https://example.invalid/').pathname.split('/products/')[1]?.replace(/\/$/, '');
      const record = approved.get(handle);
      const old = card.querySelector('.verified-card-specs');
      if (!record || anchor.textContent.trim() !== record.title.trim()) {
        if (old) old.remove();
        pending.delete(anchor);
        return;
      }
      if (old && old.dataset.product === String(record.id)) return;
      if (old) old.remove();
      if (pending.get(anchor) === record) return;
      pending.set(anchor, record);
      sourceFor(record).then(rows => {
        if (!anchor.isConnected || pending.get(anchor) !== record || anchor.textContent.trim() !== record.title.trim()) return;
        const currentHandle = new URL(anchor.href, 'https://example.invalid/').pathname.split('/products/')[1]?.replace(/\/$/, '');
        if (currentHandle !== record.handle) return;
        if (rows.length !== 4 || card.querySelector('.verified-card-specs')) return;
        const list = document.createElement('dl');
        list.className = 'verified-card-specs';
        list.dataset.product = String(record.id);
        rows.forEach(([label, value]) => {
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = label;
          description.textContent = value;
          list.append(term, description);
        });
        anchor.insertAdjacentElement('afterend', list);
      });
    });
  };
  let scheduled = false;
  const observer = new ObserverClass(() => {
    if (scheduled) return;
    scheduled = true;
    scheduleFrame(() => { scheduled = false; scan(); });
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  scan();
}


const registry=[{"id":9971969851735,"handle":"screenon-allround-game-computer-rgb-ryzen-9-rtx-3050-16gb-512gb-ssd-windows-11-pro-wifi-bluetooth","title":"ScreenON - Allround Game Computer RGB - Ryzen 9 - RTX 3050 - 16GB - 512GB SSD - Windows 11 Pro + WiFi & Bluetooth"}];
const loadSource=async handle=>{
  const url=new URL('/products/'+encodeURIComponent(handle),window.location.origin);
  url.searchParams.set('view','verified-card-data');
  const response=await fetch(url,{credentials:'same-origin',cache:'no-store'});
  if(!response.ok) return null;
  const payload=new DOMParser().parseFromString(await response.text(),'text/html').getElementById('verified-card-data');
  return payload?JSON.parse(payload.textContent):null;
};
installCardsAsync(document,registry,loadSource,DOMParser,MutationObserver,requestAnimationFrame);
  } catch(e) { console.error(e); }
})();

})();
